import { AvatarMenu } from "../menu/AvatarMenu";
import "./css/navbar.css";
import { atom } from "recoil";
import { Link } from "react-router-dom";
import { IconButton, CurrentBreadCrumb } from "@bsm/component";
import { LanguageMenu } from "components/menu/LangMenu";

export const UserNavBar = ({}: NavBarProps) => {

    return (
        <header
            className={`sticky top-0 flex z-50 backdrop-blur-lg bg-white/50 justify-between items-center gap-4 py-[10px] px-4 shadow-md`}
        >
            <img
                src={`/assets/img/logo.png`}
                alt="Logo"
                className={`h-[4rem] cursor-pointer`}
            />
            <nav>
                <ul className="flex items-center gap-4 sm:gap-6">
                    <li className="mr-[20px] flex items-end justify-end">
                        <LanguageMenu />
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export type NavBarProps = {
};

export const calendarOpenState = atom({
    key: "calendarOpenState",
    default: false,
});